module.exports = __webpack_public_path__ + "static/media/g-suite-expert.01fafe00.png";